import { fetchJSON } from "lib/fetch";
import siteConfig from "site-config";
import { stringify } from "query-string";
import isEmpty from "lodash/isEmpty";

export interface IMerchantsService {
    fetchMerchant: (merchantId: string) => Promise<nuorder.merchant.v1.Merchant>;
    fetchtUserMemberships: (
        userId: string,
        params?: Partial<nuorder.merchant.v1.ListUserMembershipsRequest>
    ) => Promise<nuorder.merchant.v1.ListMembersResponse>;
    fetchtMerchantMembers: (
        merchantId: string,
        params?: nuorder.merchant.v1.ListMembersRequest
    ) => Promise<nuorder.merchant.v1.ListMembersResponse>;
    fetch: (params?: nuorder.merchant.v1.ListMerchantsRequest) => Promise<nuorder.merchant.v1.ListMerchantsResponse>;
    fetchtFetchMerchantBrandPortals: (merchantBrandPortalId: string) => Promise<nuorder.merchant.v1.BrandPortal>;
    fetchMembershipByUserId: (merchantBrandPortalId: string, userId: string) => Promise<nuorder.merchant.v1.Member>;
    fetchListTeamMembers: (
        merchantId: string,
        teamId: string,
        params: Partial<nuorder.merchant.v1.ListTeamMembersRequest>
    ) => Promise<nuorder.merchant.v1.ListMembersResponse>;
}

export const merchants: IMerchantsService = {
    fetchMerchant: (merchantId: string) => fetchJSON(`${siteConfig.goAPI}/v1/merchants/${merchantId}`),
    fetchtUserMemberships: (userId: string, params = {}) =>
        fetchJSON(`${siteConfig.goAPI}/v1/users/${userId}/memberships?${stringify(params)}`),
    fetchtMerchantMembers: (merchantId: string, params?: nuorder.merchant.v1.ListMembersRequest) =>
        fetchJSON(
            `${siteConfig.goAPI}/v1/merchants/${merchantId}/members${!isEmpty(params) ? `?${stringify(params)}` : ""}`
        ),
    fetch: (params = {}) => fetchJSON(`${siteConfig.goAPI}/v1/merchants?${stringify(params)}`),
    fetchtFetchMerchantBrandPortals: (merchantBrandPortalId: string) =>
        fetchJSON(`${siteConfig.goAPI}/v1/merchant_brand_portals/${merchantBrandPortalId}`),
    fetchMembershipByUserId: (merchantId: string, userId: string) =>
        fetchJSON(
            `${siteConfig.goAPI}/v1/merchants/${merchantId}/get_member_by_user_id?${stringify({ user_id: userId })}`,
            {
                method: "POST",
            }
        ),
    fetchListTeamMembers: (
        merchantId: string,
        teamId: string,
        params: Partial<nuorder.merchant.v1.ListTeamMembersRequest>
    ) =>
        fetchJSON(
            `${siteConfig.goAPI}/v1/merchants/${merchantId}/teams/${teamId}/members${
                !isEmpty(params) ? `?${stringify(params)}` : ""
            }`
        ),
};
